export default "__VITE_ASSET__hx9Kq5ni__"